import { render, staticRenderFns } from "./post-slider.vue?vue&type=template&id=3d133dbb&scoped=true&"
import script from "./post-slider.vue?vue&type=script&lang=js&"
export * from "./post-slider.vue?vue&type=script&lang=js&"
import style0 from "./post-slider.vue?vue&type=style&index=0&id=3d133dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d133dbb",
  null
  
)

export default component.exports